module.exports = __webpack_public_path__ + "static/media/6.c52456b4.png";